import React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';

import { SpinnerScreen, ModalScreen, SnackBarScreen } from '@screen';

const BasicLayout = ({ children }) => (
  <>
    <CssBaseline />
    <SnackBarScreen />
    <ModalScreen />
    <SpinnerScreen />
    {children}
  </>
);

export default BasicLayout;
